import { Authenticator, ThemeProvider } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import { Auth, Hub, I18n } from "aws-amplify";
import Axios from "axios";
import React from "react";
import { Dropdown, Nav, Navbar } from "react-bootstrap";
import { connect } from "react-redux";
import { NavLink, Route, Switch, withRouter } from "react-router-dom"; // this is the same as react router
import styled from "styled-components";
import bpaLogo from "./Assets/bpaLogo.png";
import logo from "./Assets/fullsizeoutput_806.png";
import { authTheme, baseURL, formFields } from "./Constants";
import "./CSS/Dashboard.css";
import "./CSS/root.css";
import { setLoginInfo } from "./redux/actions";
import { mapStatetoProps } from "./redux/containers/login";
import LandingPageView from "./Views/LandingPage/LandingPageView.js";
import SEO from "./Views/SEO";
import { ToastAlert } from "./Views/SharedViews";
const ClassroomView = React.lazy(() =>
  import("./Components/Library/ClassroomView")
);
const MainProfileView = React.lazy(() => import("./Views/MainProfileView.js"));
const ContactView = React.lazy(() => import("./Views/ContactView.js"));
const LegalView = React.lazy(() => import("./Views/Legal/LegalView.js"));
const FAQView = React.lazy(() => import("./Views/FAQView.js"));
const QuestionsView = React.lazy(() => import("./Views/FAQPage/QuestionsView"));

const AddSuspense = (Children, scrollFun) => {
  window.removeEventListener("scroll", scrollFun);
  return (
    <React.Suspense fallback={<div>Loading...</div>}>
      <Children />
    </React.Suspense>
  );
};

const authScreenLabels = {
  en: {
    Username: "Email",
    username: "email",
  },
};
const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <button
    style={{ borderStyle: "none", outline: "none" }}
    className="nav-link nav-dropdown-opendemia"
    id="navButton"
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </button>
));

I18n.setLanguage("en");
I18n.putVocabularies(authScreenLabels);

const seoConfig = {
  title: "Opendemia",
  description:
    "Helps you write a research paper fast by keeping your research organized and generating the in-text citations and full works cited.",
  keywords: [
    "How to write a research paper",
    "How to write a research paper fast",
    "How to start a research paper",
    "Help writing a research paper",
    "Research paper tips",
  ],
};

const AuthDiv = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 20%;
`;

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      signedIn: false,
      menuBarClicked: false,
      scrolly: 0,
      initialAuthState: "signUp",
      showToast: false,
      toast: {
        title: undefined,
        message: undefined,
      },
    };
    this.setAuth(false);
  }

  toggleMenubar = () => {
    this.setState({ menuBarClicked: !this.state.menuBarClicked });
  };

  updateCurrentUser = () => {
    // updates the current logged in user to state
    Auth.currentAuthenticatedUser({
      bypassCache: false,
    })
      .then((user) => {
        Axios.defaults.headers.common.Authorization = `Bearer ${user.signInUserSession.idToken.jwtToken}`;
        this.setAuth(true);
        this.setState({ signedIn: true });
        if (window.gtag) {
          window.gtag("event", "login", {
            user_id: user.username,
            user_agent: window.navigator.userAgent,
          });
        }

        //pulls info to see if user has paid
        Axios.get(`${baseURL}/profiles/${user.username}`).then((res) => {
          // console.log("DATA1")
          // console.log(res.data)
          this.props.dispatch(setLoginInfo(res.data));
        });
      })
      .catch((err) => {
        console.log(err);
        this.setAuth(false);
        this.setState({ signedIn: false });
      });
  };

  componentDidUpdate() {
    this.setAuth(this.state.signedIn);
  }

  componentDidMount() {
    this.updateCurrentUser();

    this.props.history.listen((location) => {
      if (window.gtag) {
        window.gtag("event", "page_view", {
          page_path: location.pathname + location.search,
        });
      }
    });

    Hub.listen("auth", (data) => {
      if (data.payload.event === "signIn") {
        this.setAuth(true);
        this.setState({ signedIn: true, showToast: false });
      } else if (
        data.payload.event === "signOut" ||
        data.payload.event === "signIn_failure"
      ) {
        this.setAuth(false);
        this.setState({ signedIn: false });
      } else if (data.payload.event === "signUp_failure") {
        this.setState({
          showToast: true,
          toast: {
            title: data.payload.message,
            message: data.payload.data.message,
          },
        });
      } else if (data.payload.event === "signUp") {
        this.setState({ showToast: false });
      }
    });

    //scroll height updater
    this.updateDimensions();
    window.addEventListener("scroll", this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.updateDimensions);
  }

  updateDimensions = () => {
    this.setState({ scrolly: window.scrollY });
  };

  setAuth(state) {
    this.classroomWithAuth = this.confirmAuth(ClassroomView, state);
    this.profileWithAuth = this.confirmAuth(MainProfileView, state);
  }

  renderMenubarItems = () => (
    <Nav className="ml-auto">
      {
        /*Scrolling on homepage */
        this.state.scrolly > 450 &&
          this.props.location.pathname == "/" &&
          !this.state.signedIn && (
            <>
              <NavLink
                exact
                to="/classroom"
                onClick={() => {
                  this.setState({ initialAuthState: "signup" });
                }}
                className="nav-link btn btn-success noHoverImportant"
                id="navButton"
                style={{ position: "absolute", left: "45.5%" }}
              >
                Sign Up
              </NavLink>

              <NavLink
                exact
                to="/classroom"
                onClick={() => {
                  this.setState({ initialAuthState: "signIn" });
                }}
                className="nav-link btn btn-outline-secondary"
                id="navButton"
                style={{
                  marginLeft: "10px",
                  marginRight: "3em",
                  position: "absolute",
                  left: "51.5%",
                }}
              >
                Sign In
              </NavLink>
            </>
          )
      }

      {/* {
        this.props.location.pathname == "/classroom" && !this.props.paid && this.state.signedIn &&
        <NavLink exact to="/Pricing" className="nav-link btn btn-success" id="navButton">
          Upgrade
        </NavLink>
      } */}

      <Dropdown>
        <Dropdown.Toggle as={CustomToggle}>
          Help
          {/* &#x25bc; */}
        </Dropdown.Toggle>
        <Dropdown.Menu className="nav-dropdown-opendemia-inside">
          <Dropdown.Item>
            <NavLink exact to="/FAQ">
              Tutorial
            </NavLink>
          </Dropdown.Item>
          <Dropdown.Item>
            <NavLink exact to="/Questions">
              FAQ
            </NavLink>
          </Dropdown.Item>
          <Dropdown.Item>
            <NavLink exact to="/Contact">
              Contact
            </NavLink>
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>

      {this.state.signedIn && (
        <>
          <NavLink exact to="/classroom" className="nav-link" id="navButton">
            Library
          </NavLink>
          <NavLink exact to="/Profile" className="nav-link" id="navButton">
            Profile
          </NavLink>
        </>
      )}

      {!this.state.signedIn && true && (
        <>
          {/* <NavLink exact to="/classroom"  onClick={k =>{alert("clickedsup")}}style={{ color: 'white' }}>
            Sign Up
          </NavLink> */}
          <NavLink
            exact
            to="/classroom"
            className="nav-link"
            onClick={() => {
              this.setState({ initialAuthState: "signIn" });
            }}
            id="navButton"
          >
            Sign In
          </NavLink>
        </>
      )}
    </Nav>
  );

  confirmAuth = (Children, state) =>
    state ? (
      AddSuspense(Children, this.updateDimensions)
    ) : (
      <AuthDiv>
        <ThemeProvider theme={authTheme}>
          <Authenticator
            initialState={this.state.initialAuthState}
            formFields={formFields}
          />
        </ThemeProvider>
      </AuthDiv>
    );

  setStateToSignin = () => {
    this.setState({ initialAuthState: "signIn" });
  };

  getSubdomain = () => {
    const hostname = window.location.hostname; // "app.example.com"
    const parts = hostname.split("."); // ["app", "example", "com"]

    return parts[0];
  };

  render() {
    return (
      <div id="outerDiv">
        <SEO {...seoConfig} />
        {/* <AlertBar
          show={this.props.location.pathname === "/"}
          text={alertText}
        /> */}
        <Navbar
          id="dashboard"
          className="testHeader"
          collapseOnSelect
          expand="lg"
          sticky="top"
        >
          <Navbar.Brand href="/" style={{ display: "flex" }}>
            <img src={logo} className="logoClass" alt="logo" />
            {this.props.paid && <span className="shiny">PRO</span>}
            {this.getSubdomain() === "bpa" && (
              <React.Fragment>
                <div
                  style={{
                    borderLeft: "2px solid #000",
                    height: "35px",
                    margin: "auto 10px",
                  }}
                />
                <img src={bpaLogo} className="logoClass" alt="logo" />
              </React.Fragment>
            )}
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            style={{ filter: "" }}
          />
          <Navbar.Collapse id="basic-navbar-nav">
            {this.renderMenubarItems()}
          </Navbar.Collapse>
        </Navbar>
        <div className="content">
          {this.state.showToast && (
            <ToastAlert
              title={this.state.toast.title}
              message={this.state.toast.message}
            />
          )}
          <Switch>
            <Route
              exact="true"
              path="/"
              render={(props) => (
                <LandingPageView
                  {...props}
                  signedIn={this.state.signedIn}
                  setUpperStateToLogin={this.setStateToSignin}
                />
              )}
            />
            <Route
              exact="true"
              path="/index.html"
              component={LandingPageView}
            />

            <Route path="/classroom" render={() => this.classroomWithAuth} />

            <Route path="/Profile" render={() => this.profileWithAuth} />
            {/* <Route
              exact
              path="/Feedback"
              component={this.feedbackWithAuth}
            /> */}
            <Route
              exact
              path="/Contact"
              render={() => AddSuspense(ContactView, this.updateDimensions)}
            />
            <Route
              exact
              path="/FAQ"
              render={() => AddSuspense(FAQView, this.updateDimensions)}
            />
            <Route
              exact
              path="/Legal"
              render={() => AddSuspense(LegalView, this.updateDimensions)}
            />
            <Route
              exact
              path="/Questions"
              render={() => AddSuspense(QuestionsView, this.updateDimensions)}
            />

            <Route
              path="*"
              render={() => <LandingPageView signedIn={this.state.signedIn} />}
            />
          </Switch>
        </div>
      </div>
    );
  }
}

export default withRouter(connect(mapStatetoProps)(Dashboard));
